module.exports = __webpack_public_path__ + "static/media/Hours.dc76aa21.svg";